import { useEffect, useState } from "react";

const KEY = "rtn:admin-view-as-user";

export function useAdminMode() {
  const [viewAsUser, setViewAsUserState] = useState<boolean>(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    setViewAsUserState(window.localStorage.getItem(KEY) === "1");
    const handler = (e: StorageEvent) => {
      if (e.key === KEY) setViewAsUserState(e.newValue === "1");
    };
    window.addEventListener("storage", handler);
    return () => window.removeEventListener("storage", handler);
  }, []);

  const setViewAsUser = (v: boolean) => {
    if (typeof window !== "undefined") {
      window.localStorage.setItem(KEY, v ? "1" : "0");
    }
    setViewAsUserState(v);
    // Notify listeners in same tab
    window.dispatchEvent(new StorageEvent("storage", { key: KEY, newValue: v ? "1" : "0" }));
  };

  return { viewAsUser, setViewAsUser };
}
